import React from 'react'
import styled from '@emotion/styled'

import { Box } from '../Box/Box'
import { Icon } from '../Icon/Icon'
import { Text } from '../Text/Text'

export interface FieldMessageProps {
  children: React.ReactNode
  tone?: 'light' | 'positive' | 'negative'
}

export const FieldMessage: React.FC<FieldMessageProps> = ({ children, tone = 'light' }) => {
  return (
    <Box height={12} display="flex" alignItems="center">
      {tone !== 'light' ? (
        <Icon
          name={tone === 'negative' ? 'critical-hollow' : 'success-hollow'}
          tone={tone}
          size="s"
        />
      ) : null}
      <StyledBox marginLeft="xxs">
        <Text tone={tone} size="small">
          {children}
        </Text>
      </StyledBox>
    </Box>
  )
}

const StyledBox = styled(Box)`
  padding-bottom: 2px;
`
